import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Paragraph from '@tiptap/extension-paragraph';
import StarterKit from '@tiptap/starter-kit';
import Document from '@tiptap/extension-document';
import Text from '@tiptap/extension-text';
import { CSSProperties } from 'react';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Color from '@tiptap/extension-color';
import TextStyle from '@tiptap/extension-text-style';
import FontSize from 'tiptap-extension-font-size';

const Extentions = {
  MINIMAL: [
    Document.extend({
      content: 'block',
    }),
    Text,
    Paragraph,
  ],
  MINIMAL_AGREEMENTS_INPUT: [
    Document.extend({
      content: 'block',
    }),
    Text,
    Paragraph,
    Link.configure({
      openOnClick: false,
      autolink: true,
    }),
    Color,
    TextStyle,
    Bold,
    Italic,
    Underline,
  ],
  EXTENDED: [
    StarterKit.configure({
      code: false,
      codeBlock: false,
      dropcursor: false,
      horizontalRule: false,
      heading: false,
      bulletList: false,
      orderedList: false,
    }),
    Link.configure({
      openOnClick: false,
      autolink: true,
    }),
    Underline,
    TextStyle,
    Color,
    FontSize,
    Bold.extend({
      renderHTML({ HTMLAttributes }) {
        return ['b', HTMLAttributes, 0];
      },
      parseHTML() {
        return [{ tag: 'b' }, { tag: 'strong' }];
      },
    }),
    Italic.extend({
      renderHTML({ HTMLAttributes }) {
        return ['i', HTMLAttributes, 0];
      },
      parseHTML() {
        return [{ tag: 'i' }, { tag: 'em' }];
      },
    }),
  ],
};

const TextAreaStyles: CSSProperties = {
  minHeight: 250,
};

const TextInputStyles: CSSProperties = {
  minHeight: 32,
};

const removeParagraphWrapper = (htmlString: string) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = htmlString.trim();
  const { firstElementChild } = wrapper;
  if (firstElementChild && firstElementChild.tagName === 'P' && wrapper.childElementCount === 1) {
    return firstElementChild.innerHTML;
  }
  return htmlString;
};

function convertParagraphsToBreaks(html: string): string {
  if (typeof document === 'undefined') return html;

  const wrapper = document.createElement('div');
  wrapper.innerHTML = html.trim();

  // Replace all <p> with its children + <br>
  const paragraphs = wrapper.querySelectorAll('p');
  paragraphs.forEach((p) => {
    const br = document.createElement('br');
    const frag = document.createDocumentFragment();
    while (p.firstChild) {
      frag.appendChild(p.firstChild);
    }
    frag.appendChild(br);
    p.replaceWith(frag);
  });

  // Remove trailing <br>
  return wrapper.innerHTML.trim().replace(/(<br\s*\/?>)+$/i, '');
}

// eslint-disable-next-line import/prefer-default-export
export const TiptapS = {
  Extentions,
  removeParagraphWrapper,
  TextAreaStyles,
  TextInputStyles,
  convertParagraphsToBreaks,
};
